export const DISCOUNT_CODE_SUCCESS_BASE_MESSAGE =
  "exhibitor.cart.discount.applied_success";

export enum DiscountCodeError {
  NotFound = "DISCOUNT_CODE_NOT_FOUND",
  UsageLimitReached = "DISCOUNT_CODE_USAGE_LIMIT_REACHED",
  Expired = "DISCOUNT_CODE_EXPIRED",
  CategoryMismatch = "CATEGORY_MISMATCH",
  NoMatchingProducts = "DISCOUNT_CODE_NO_MATCHING_PRODUCTS",
}

export const DISCOUNT_CODE_ERROR_MESSAGE: Record<DiscountCodeError, string> = {
  [DiscountCodeError.Expired]: "exhibitor.cart.discount.error.expired",
  [DiscountCodeError.NotFound]: "exhibitor.cart.discount.error.invalid",
  [DiscountCodeError.UsageLimitReached]:
    "exhibitor.cart.discount.error.usage_limit",
  [DiscountCodeError.CategoryMismatch]:
    "exhibitor.cart.discount.error.category_mismatch",
  [DiscountCodeError.NoMatchingProducts]:
    "exhibitor.cart.discount.error.no_products",
};
